import { render, staticRenderFns } from "./ReleaseNotesEntry.vue?vue&type=template&id=09e28fbb&scoped=true"
import script from "./ReleaseNotesEntry.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesEntry.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesEntry.vue?vue&type=style&index=0&id=09e28fbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e28fbb",
  null
  
)

export default component.exports